/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { IdentifyGeneralInfoDto } from '../../models/identify-general-info-dto';

export interface GetGeneralInfo$Params {
  coordinates: Array<string>;
}

export function getGeneralInfo(
  http: HttpClient,
  rootUrl: string,
  params: GetGeneralInfo$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<IdentifyGeneralInfoDto>> {
  const rb = new RequestBuilder(rootUrl, getGeneralInfo.PATH, 'get');
  if (params) {
    rb.query('coordinates', params.coordinates, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IdentifyGeneralInfoDto>;
      }),
    );
}

getGeneralInfo.PATH = '/identify/parcel/generalInfo';
